
import { computed, defineComponent, inject, ref } from 'vue'
import { useDailyReport } from '@/composable/useDailyReport'
import DailyReportExternalTrafficTableRow from './DailyReportExternalTrafficTableRow.vue'
import {
  DailyReportExternalTrafficData,
  dailyReportExternalTrafficDataKey,
} from '@/pages/DailyReportExternalPreview.vue'
import { useProfile } from '@/composable/useProfile'

export default defineComponent({
  name: 'DailyReportExternalTrafficTable',

  components: { DailyReportExternalTrafficTableRow },

  setup() {
    const { currentProject } = useProfile()
    const { data, isPrintMode, expandedTrafficRows } = useDailyReport()

    const colStyle = computed(() =>
      currentProject.value?.name === 'pendeltag'
        ? 'white-space: no-wrap; '
        : 'white-space: pre-wrap; word-break: break-all;'
    )

    const showMonthData = ref(false)
    const columns = inject<DailyReportExternalTrafficData>(
      dailyReportExternalTrafficDataKey
    ) as DailyReportExternalTrafficData

    return {
      data,
      columns,
      isPrintMode,
      colStyle,
      expandedTrafficRows,
      showMonthData,
      currentProject,
    }
  },
})
